type SeoConfig = {
  title: string;
  description: string;
  canonical: string;
};

const origin = "https://swiftmobilemechanics.com";

export const seoByPath: Record<string, SeoConfig> = {
  "/": {
    title: "Swift Mobile Mechanic | Mobile Auto Repair in Winnipeg",
    description:
      "Swift Mobile Mechanic provides mobile auto repair, diagnostics, brakes, oil changes, inspections, and roadside mechanic service at your location in Winnipeg, Manitoba.",
    canonical: `${origin}/`,
  },
  "/services": {
    title: "Mobile Mechanic Services in Winnipeg | Swift Mobile Mechanic",
    description:
      "Explore mobile mechanic services in Winnipeg, including brake repair, diagnostics, oil changes, battery service, inspections, A/C service, and roadside repairs.",
    canonical: `${origin}/services`,
  },
  "/about": {
    title: "About Swift Mobile Mechanic | Winnipeg Mobile Auto Repair",
    description:
      "Learn about Swift Mobile Mechanic, a Winnipeg mobile auto repair service built around honest communication, transparent pricing, and on-site convenience.",
    canonical: `${origin}/about`,
  },
  "/book": {
    title: "Book a Mobile Mechanic in Winnipeg | Swift Mobile Mechanic",
    description:
      "Request a mobile mechanic appointment in Winnipeg for diagnostics, maintenance, brake repair, inspections, and roadside vehicle service at your location.",
    canonical: `${origin}/book`,
  },
  "/contact": {
    title: "Contact Swift Mobile Mechanic | Winnipeg Mobile Mechanic",
    description:
      "Contact Swift Mobile Mechanic for mobile auto repair in Winnipeg. Call, text, WhatsApp, or send a service request for help with your vehicle.",
    canonical: `${origin}/contact`,
  },
  "/privacy": {
    title: "Privacy Policy | Swift Mobile Mechanic",
    description:
      "Read the Swift Mobile Mechanic privacy policy for information about contact forms, customer details, and website data.",
    canonical: `${origin}/privacy`,
  },
  "/warranty": {
    title: "Warranty Policy | Swift Mobile Mechanic",
    description:
      "Read the Swift Mobile Mechanic warranty policy for mobile auto repair labour, parts, and service terms in Winnipeg.",
    canonical: `${origin}/warranty`,
  },
};

function setMeta(selector: string, attr: "content" | "href", value: string) {
  const node = document.head.querySelector(selector);
  if (node) {
    node.setAttribute(attr, value);
  }
}

export function applySeo(pathname: string) {
  const seo = seoByPath[pathname] ?? seoByPath["/"];

  document.title = seo.title;
  setMeta('meta[name="description"]', "content", seo.description);
  setMeta('link[rel="canonical"]', "href", seo.canonical);
  setMeta('meta[property="og:title"]', "content", seo.title);
  setMeta('meta[property="og:description"]', "content", seo.description);
  setMeta('meta[property="og:url"]', "content", seo.canonical);
  setMeta('meta[name="twitter:title"]', "content", seo.title);
  setMeta('meta[name="twitter:description"]', "content", seo.description);
}
